import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
	UpsertUserWithdrawalFeeRequest,
	UserWithdrawalFee,
} from "src/providers/user-provider";
import userProvider from "src/providers/user-provider";

const withdrawalFeeQueries = {
	listUserWithdrawalFees: (userId: string) => {
		return useQuery<UserWithdrawalFee[]>({
			queryKey: ["users", userId, "withdrawal-fees"],
			queryFn: () => userProvider.getUserWithdrawalFees(userId),
			enabled: !!userId,
		});
	},

	upsertUserWithdrawalFee: () => {
		const queryClient = useQueryClient();

		return useMutation({
			mutationFn: ({
				userId,
				fee,
			}: {
				userId: string;
				fee: UpsertUserWithdrawalFeeRequest;
			}) => userProvider.upsertUserWithdrawalFee(userId, fee),
			onSuccess: (_data, variables) => {
				queryClient.invalidateQueries({
					queryKey: ["users", variables.userId, "withdrawal-fees"],
				});
			},
		});
	},

	deleteUserWithdrawalFee: () => {
		const queryClient = useQueryClient();

		return useMutation({
			mutationFn: ({
				userId,
				ticker,
				feeProfile,
			}: {
				userId: string;
				ticker: string;
				feeProfile?: string | null;
			}) => userProvider.deleteUserWithdrawalFee(userId, ticker, feeProfile),
			onSuccess: (_data, variables) => {
				queryClient.invalidateQueries({
					queryKey: ["users", variables.userId, "withdrawal-fees"],
				});
			},
		});
	},
};

export default withdrawalFeeQueries;
